let selectedChipName = "YTD";

export const updateSelectedChipNameHighlights = (chipName) => {
  selectedChipName = chipName;
};


export const getSelectedChipName = () => {
  return selectedChipName;
};
